export enum IframeMessage {
  // 微信登录获取到 code
  // data:
  //  code: string
  WX_GET_CODE,
}
